/**
 * 엑셀 클립보드 TSV 규칙 (순수 함수)
 * - 엑셀은 셀 값에 탭·줄바꿈·큰따옴표(맨 앞)가 있으면 그 셀을 "…" 로 감싸고 안의 " 를 "" 로 바꿔 복사한다.
 * - 붙여넣기: 감싼 필드 안의 탭·줄바꿈은 값으로 읽고 "" 를 " 로 푼다. 행 끝 줄바꿈 하나는 무시.
 * - 감싸기가 닫히지 않은 글(메모장에서 " 로 시작하는 글을 복사한 경우 등)은 예전처럼 줄·탭으로만 나눈다.
 */
/** TSV 글 → 행·열 문자열 */
export function parseTsv(text) {
    const rows = [];
    let row = [], f = '', start = true, i = 0;
    const n = text.length;
    while (i < n) {
        const ch = text[i];
        if (start && ch === '"') {
            let j = i + 1, closed = false, v = '';
            while (j < n) {
                const c = text[j];
                if (c === '"') {
                    if (text[j + 1] === '"') {
                        v += '"';
                        j += 2;
                        continue;
                    }
                    closed = true;
                    j++;
                    break;
                }
                v += c;
                j++;
            }
            if (!closed)
                return naiveTsv(text);
            f = v;
            i = j;
            start = false;
            continue;
        }
        if (ch === '\t') {
            row.push(f);
            f = '';
            start = true;
            i++;
            continue;
        }
        if (ch === '\r' || ch === '\n') {
            row.push(f);
            rows.push(row);
            row = [];
            f = '';
            start = true;
            i += ch === '\r' && text[i + 1] === '\n' ? 2 : 1;
            continue;
        }
        f += ch;
        start = false;
        i++;
    }
    if (!start || f !== '' || row.length) {
        row.push(f);
        rows.push(row);
    }
    return rows;
}
/** 따옴표 규칙 없이 줄·탭으로만 (예전 동작) */
function naiveTsv(text) {
    return text.replace(/\r?\n$/, '').split(/\r?\n/).map(l => l.split('\t'));
}
/** 셀 값 → TSV 필드: 탭·줄바꿈이 있거나 " 로 시작하면 "…" 로 감싸고 " 를 "" 로 */
export function tsvField(s) {
    return /[\t\r\n]/.test(s) || s.startsWith('"') ? '"' + s.replace(/"/g, '""') + '"' : s;
}
